"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var eappBridge = function (method, params) {
    return new Promise(function (resolve, reject) {
        dd.dtBridge({
            m: method,
            args: params,
            onSuccess: function (result) {
                if (typeof params.onSuccess === 'function') {
                    params.onSuccess(result);
                }
                resolve(result);
            },
            onFail: function (err) {
                if (typeof params.onFail === 'function') {
                    params.onFail(err);
                }
                reject(err);
            },
        });
    });
};
exports.default = eappBridge;
